import { createEvent, createStore } from 'effector';
import { useUnit } from 'effector-react';
import containerId from '~/client/layout/BaseLayout/LoyaltyMicroFrontend/constant/containerId';

type LoyaltyConfigStore = {
  isLoyaltyOpen?: boolean;
};
type SetLoyaltyOpenFn = {
  isLoyaltyOpen: boolean;
  query?: string;
};

const loyaltyStore = createStore<LoyaltyConfigStore>({});
const setLoyaltyOpen = createEvent<SetLoyaltyOpenFn>();
loyaltyStore.on(setLoyaltyOpen, (store, { isLoyaltyOpen, query = 'home' }) => {
  const closingAction = isLoyaltyOpen === false;
  const url = new URL(global.location.href);
  if (closingAction) {
    const isBottomNavigation = document.getElementById('bottom-menu');
    global.Comms?.('update', {
      styles: {
        frame: { right: '20px' },
        button: { bottom: isBottomNavigation ? 80 : 20 },
      },
    });
    const commsButton = document
      .getElementById('comms')
      ?.getElementsByTagName('button')?.[0];
    commsButton?.setAttribute('style', 'display:flex');
    url.searchParams.delete('l');
    global.history.replaceState(global.history.state, '', url);
    global.Loyalty?.unmount?.({
      containerId: containerId.app,
      componentName: 'app',
    });
  } else if (!url.searchParams.get('l')) {
    url.searchParams.set('l', query);
    global.history.replaceState(global.history.state, '', url);
  }
  return { ...store, isLoyaltyOpen };
});

type SetWidgetOpenFn = {
  isWidgetOpen: boolean;
};
type LoyaltyWidgetConfigStore = {
  isWidgetOpen?: boolean;
};
const loyaltyWidgetStore = createStore<LoyaltyWidgetConfigStore>({});
const setLoyaltyWidget = createEvent<SetWidgetOpenFn>();

loyaltyWidgetStore.on(setLoyaltyWidget, (store, { isWidgetOpen }) => ({
  ...store,
  isWidgetOpen,
}));

const useLoyaltyStore = () => {
  const store = useUnit(loyaltyStore);
  const widgetStore = useUnit(loyaltyWidgetStore);

  return {
    setLoyaltyOpen,
    setLoyaltyWidget,
    isWidgetOpen: false,
    ...widgetStore,
    isLoyaltyOpen: false,
    ...store,
  };
};
export default useLoyaltyStore;
